import { Popconfirm } from 'antd';
import dayjs from 'dayjs';
import i18next from 'i18next';
import React from 'react';
import { FaEye, FaPencilAlt, FaRegTrashAlt } from 'react-icons/fa';
import Button from '~/components/Button';
import Can from '~/components/Can';
import Cannot from '~/components/Cannot';
import Strong from '~/components/Strong';
import { TableActions } from '~/components/Table';
import { formatPrice } from '~/Utils/format';

export const expensesColumns = (handleEdit, handleDelete, isMobile) => {
  if (isMobile) {
    return [
      {
        dataIndex: 'summary',
        key: 'summary',
        render: (_, record) => (
          <div>
            <Strong>{i18next.t('screens:default.name')}:</Strong> {record?.name}
            <br />
            <TableActions align="center" justify="center" isMobile={isMobile}>
              <Can permission="@eventsExpenses/edit">
                <Button size="small" title="Editar" onClick={() => handleEdit(record)}>
                  <FaPencilAlt />
                </Button>
              </Can>
              <Cannot permission="@eventsExpenses/edit">
                <Button size="small" title="Visualizar" onClick={() => handleEdit(record)}>
                  <FaEye />
                </Button>
              </Cannot>
              <Can permission="@eventsExpenses/delete">
                <Popconfirm
                  title={i18next.t('messages:confirmDelete')}
                  okText={i18next.t('messages:yes')}
                  onConfirm={() => handleDelete(record.id)}
                  cancelText={i18next.t('messages:no')}
                >
                  <Button size="small" title="Excluir">
                    <FaRegTrashAlt />
                  </Button>
                </Popconfirm>
              </Can>
            </TableActions>
          </div>
        ),
      },
    ];
  }

  return [
    {
      title: i18next.t('screens:default.name'),
      dataIndex: 'name',
      key: 'name',
      render: (text, record) => record.name,
    },
    {
      title: i18next.t('screens:default.actions'),
      dataIndex: 'actions',
      key: 'actions',
      width: '140px',
      align: 'center',
      render: (text, record) => (
        <TableActions align="center" justify="center">
          <Can permission="@eventsEeventsExpenses/edit">
            <Button size="small" title="Editar" onClick={() => handleEdit(record)}>
              <FaPencilAlt />
            </Button>
          </Can>
          <Cannot permission="@eventsExpenses/edit">
            <Button size="small" title="Visualizar" onClick={() => handleEdit(record)}>
              <FaEye />
            </Button>
          </Cannot>
          <Can permission="@eventsExpenses/delete">
            <Popconfirm
              title={i18next.t('messages:confirmDelete')}
              okText={i18next.t('messages:yes')}
              onConfirm={() => handleDelete(record.id)}
              cancelText={i18next.t('messages:no')}
            >
              <Button size="small" title="Excluir">
                <FaRegTrashAlt />
              </Button>
            </Popconfirm>
          </Can>
        </TableActions>
      ),
    },
  ];
};

export const recordingExpensesColomns = (handleEdit, handleDelete, isMobile) => {
  if (isMobile) {
    return [
      {
        dataIndex: 'summary',
        key: 'summary',
        render: (_, record) => {
          const months = ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'];

          return (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', padding: '8px 0' }}>
              <div>
                <Strong>{i18next.t('screens:default.name')}:</Strong> {record?.name}
              </div>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', fontSize: '13px' }}>
                {months.map((m) => {
                  if (record[m] > 0) {
                    return (
                      <span key={m} style={{ backgroundColor: '#f0f0f0', padding: '2px 6px', borderRadius: '4px' }}>
                        <Strong>{i18next.t(m.charAt(0).toUpperCase() + m.slice(1))}:</Strong>{' '}
                        {formatPrice(record[m], false)}
                      </span>
                    );
                  }
                  return null;
                })}
              </div>

              <div style={{ fontSize: '15px', color: '#ffbb00' }}>
                <Strong>{i18next.t('Total')}:</Strong> {formatPrice(record?.total || 0, false)}
              </div>
            </div>
          );
        },
      },
    ];
  }

  // O seu desktop arrumado (corrigi o typo no eventsEeventsExpenses)
  return [
    {
      title: i18next.t('screens:default.name'),
      dataIndex: 'name',
      key: 'name',
      render: (text) => text,
    },
    {
      title: i18next.t('Jan'),
      dataIndex: 'jan',
      key: 'jan',
      render: (text) => formatPrice(text, false),
    },
    {
      title: i18next.t('Fev'),
      dataIndex: 'fev',
      key: 'fev',
      render: (text) => formatPrice(text, false),
    },
    {
      title: i18next.t('Mar'),
      dataIndex: 'mar',
      key: 'mar',
      render: (text) => formatPrice(text, false),
    },
    {
      title: i18next.t('Abr'),
      dataIndex: 'abr',
      key: 'abr',
      render: (text) => formatPrice(text, false),
    },
    {
      title: i18next.t('Mai'),
      dataIndex: 'mai',
      key: 'mai',
      render: (text) => formatPrice(text, false),
    },
    {
      title: i18next.t('Jun'),
      dataIndex: 'jun',
      key: 'jun',
      render: (text) => formatPrice(text, false),
    },
    {
      title: i18next.t('Jul'),
      dataIndex: 'jul',
      key: 'jul',
      render: (text) => formatPrice(text, false),
    },
    {
      title: i18next.t('Ago'),
      dataIndex: 'ago',
      key: 'ago',
      render: (text) => formatPrice(text, false),
    },
    {
      title: i18next.t('Set'),
      dataIndex: 'set',
      key: 'set',
      render: (text) => formatPrice(text, false),
    },
    {
      title: i18next.t('Out'),
      dataIndex: 'out',
      key: 'out',
      render: (text) => formatPrice(text, false),
    },
    {
      title: i18next.t('Nov'),
      dataIndex: 'nov',
      key: 'nov',
      render: (text) => formatPrice(text, false),
    },
    {
      title: i18next.t('Dez'),
      dataIndex: 'dez',
      key: 'dez',
      render: (text) => formatPrice(text, false),
    },
    {
      title: i18next.t('Total'),
      dataIndex: 'total',
      key: 'total',
      render: (text) => formatPrice(text, false),
    },
    // {
    //   title: i18next.t('screens:default.actions'),
    //   dataIndex: 'actions',
    //   key: 'actions',
    //   width: '140px',
    //   align: 'center',
    //   render: (text, record) => (
    //     <TableActions align="center" justify="center">
    //       <Can permission="@eventsExpenses/edit">
    //         <Button size="small" title="Editar" onClick={() => handleEdit(record)}>
    //           <FaPencilAlt />
    //         </Button>
    //       </Can>
    //       <Cannot permission="@eventsExpenses/edit">
    //         <Button size="small" title="Visualizar" onClick={() => handleEdit(record)}>
    //           <FaEye />
    //         </Button>
    //       </Cannot>
    //       <Can permission="@eventsExpenses/delete">
    //         <Popconfirm
    //           title={i18next.t('messages:confirmDelete')}
    //           okText={i18next.t('messages:yes')}
    //           onConfirm={() => handleDelete(record.id)}
    //           cancelText={i18next.t('messages:no')}
    //         >
    //           <Button size="small" title="Excluir">
    //             <FaRegTrashAlt />
    //           </Button>
    //         </Popconfirm>
    //       </Can>
    //     </TableActions>
    //   ),
    // },
  ];
};

export const viewExpenseColumns = (isMobile) => {
  if (isMobile) {
    return [
      {
        dataIndex: 'summary',
        key: 'summary',
        render: (_, record) => {
          const months = ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'];

          return (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', padding: '8px 0' }}>
              <div>
                <Strong>{i18next.t('screens:default.name')}:</Strong> {record?.name}
              </div>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', fontSize: '13px' }}>
                {months.map((m) => {
                  if (record[m] > 0) {
                    return (
                      <span key={m} style={{ backgroundColor: '#f0f0f0', padding: '2px 6px', borderRadius: '4px' }}>
                        <Strong>{i18next.t(m.charAt(0).toUpperCase() + m.slice(1))}:</Strong>{' '}
                        {formatPrice(record[m], false)}
                      </span>
                    );
                  }
                  return null;
                })}
              </div>

              <div style={{ fontSize: '15px', color: '#ffbb00' }}>
                <Strong>{i18next.t('Total')}:</Strong> {formatPrice(record?.total || 0, false)}
              </div>
            </div>
          );
        },
      },
    ];
  }

  return [
    {
      title: i18next.t('Mês'),
      dataIndex: 'month',
      key: 'month',
      render: (text, record) => dayjs(record.spent_at).format('MMMM').toUpperCase(),
    },
    {
      title: i18next.t('Data'),
      dataIndex: 'spent_at',
      key: 'spent_at',
      render: (text) => text,
    },
    {
      title: i18next.t('Descrição'),
      dataIndex: 'description',
      key: 'description',
      render: (text) => text,
    },
    {
      title: i18next.t('Valor'),
      dataIndex: 'price',
      key: 'price',
      render: (text) => formatPrice(text, false),
    },
  ];
};
